import React from 'react';
import {formatPersianDigits} from '../helpers/Utils';

const API_STAGE = 'https://newapi.pezeshket.com';
const API_PRODUCTION = 'https://api.pezeshket.com';
const API_DEVELOP = 'https://devapi.pezeshket.com';
const API_LOCAL = 'http://localhost:60500';
const LOCAL_PORT = '60508';

//@ts-ignore
// eslint-disable-next-line no-undef
console.log(__STAGE__);
// eslint-disable-next-line no-undef
global.__STAGE__ = __STAGE__;
//@ts-ignore
// eslint-disable-next-line no-undef
global.__PRODUCTION__ = __PRODUCTION__;

export const production = global.__PRODUCTION__; //process.env.NODE_ENV === "production";
export function getBaseUrl() {
  if (global.__STAGE__) {
    return API_STAGE;
  } else if (global.__PRODUCTION__) {
    return API_PRODUCTION;
    // eslint-disable-next-line no-undef
  } else if (
    typeof window !== 'undefined' &&
    ['localhost', '127.0.0.1'].includes(window.location.hostname) && [LOCAL_PORT].includes(window.location.port)
  ) {
    return API_LOCAL;
  } else {
    return API_DEVELOP;
  }
}

export const application = {
  adminCoreEndpoint: `${getBaseUrl()}/adminCore/v1`,
  newsEndpoint: `${getBaseUrl()}/news/v1`,
  supportEndpoint: `${getBaseUrl()}/support/v1`,
  educationalEndpoint: `${getBaseUrl()}/educational/v1`,
  socialEndpoint: `${getBaseUrl()}/social/v1`,
  coreEndpoint: `${getBaseUrl()}/core/v1`,
  walletEndpoint: `${getBaseUrl()}/wallet/v1`,
  advertiseEndpoint: `${getBaseUrl()}/affiliation`,
  sessionsListEndpoint: `${getBaseUrl()}/core/v1`,
  tokenPath: '/oauth/token',
  id: 'd9008cd7-a427-4d02-8c43-536599660c22',
};

export const reactTableText = {
  showPageJump: false,
  renderCurrentPage: page => formatPersianDigits(page + 1),
  renderTotalPagesCount: pages => formatPersianDigits(pages || 1),
  renderPageSizeOptions: ({
    pageSize,
    pageSizeOptions,
    rowsSelectorText,
    onPageSizeChange,
    rowsText,
  }) => (
    <span className="select-wrap -pageSizeOptions">
      <select
        aria-label={rowsSelectorText}
        onChange={event => onPageSizeChange(Number(event.target.value))}
        value={pageSize}
      >
        {pageSizeOptions.map(option => (
          <option key={option} value={option}>
            {`${formatPersianDigits(option)} ${rowsText}`}
          </option>
        ))}
      </select>
    </span>
  ),
  previousText: 'صفحه قبل',
  nextText: 'صفحه بعد',
  loadingText: 'بارگزاری...',
  noDataText: 'هیج ردیفی پیدا نشد',
  pageText: 'صفحه',
  ofText: 'از',
  rowsText: 'ردیف',
};
